'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('record-votes', {
      url: '/voting/:voteId/record-votes/:ballotId',
      template: '<record-votes></record-votes>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/ballot/record-votes/record-votes.routes.js